import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as personnel from '../../personnel'

export const RESOURCE = {
  payload: {
    description: 'A regular check-in from an employee',
    dimension: personnel.RESOURCE.payload,
    name: 'Check-In',
    partialId: PartialId.Standard.create('check_in'),
  },
  type: core.quiver.Resource.Type.DmsSnapshot,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsSnapshot>

export const MODEL_ID = core.dms.models.Snapshot.Id.from({
  context: core.dms.models.Snapshot.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
